import { NamedRoutes } from '@/routes/routes';

export type SimpleRoute = {
  name: string;
  params?: any;
  query?: any;
};

const ROUTE_NAME_KEY = 'afterAuthRedirect';
const QUERY_KEY = 'afterAuthQuery';
const PARAMS_KEY = 'afterAuthParams';

class AuthRedirect {
  getRedirect(): SimpleRoute {
    const routeName = localStorage.getItem(ROUTE_NAME_KEY);
    const query = localStorage.getItem(QUERY_KEY);
    const params = localStorage.getItem(PARAMS_KEY);

    return {
      name: routeName || '',
      query: query ? JSON.parse(query) : undefined,
      params: params ? JSON.parse(params) : undefined,
    };
  }

  setRedirect(route: SimpleRoute) {
    this.resetRedirectData();

    localStorage.setItem(ROUTE_NAME_KEY, route.name);
    if (route.query) {
      localStorage.setItem(QUERY_KEY, JSON.stringify(route.query));
    }
    if (route.params) {
      localStorage.setItem(PARAMS_KEY, JSON.stringify(route.params));
    }
  }

  resetRedirectData() {
    localStorage.removeItem(ROUTE_NAME_KEY);
    localStorage.removeItem(QUERY_KEY);
    localStorage.removeItem(PARAMS_KEY);
  }
}

export default new AuthRedirect();
